export const sendSignOutBeacon = (payload: object) => {
  const url = '/analytics/signout';
  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
  }
};
